import React, { useEffect } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import FavoriteProductEditItem from "@/features/my-account/favorite-product-edit-item";
import useGetFavSkus from "@/features/my-account/hooks/useGetFavSkus";
import { useVirtualizer } from "@tanstack/react-virtual";
import { FieldArray, useFormikContext } from "formik";
import {
  FavoriteProductFormikValues,
  FavSkuItem,
} from "@/features/my-account/types";
import NoResults from "@/shared/components/no-results";
import NoResultCustom from "@/shared/components/no-result-simple";

interface Props {
  favSkus: FavSkuItem[];
}

function AddedSkuList({ favSkus }: Props) {
  const parentRef = React.useRef<HTMLDivElement>(null);

  const { values, setFieldValue } =
    useFormikContext<FavoriteProductFormikValues>();

  const { favoriteProducts, requestSku } = values;

  // const refinedFavSkus = favSkus.filter((item) => item.sku_in_pathrade);

  // const rowVirtualizer = useVirtualizer({
  //   count: favSkus.length,
  //   getScrollElement: () => parentRef.current,
  //   estimateSize: () => 76,
  // });

  return (
    <>
      <Flex gap={"4px"}>
        <Text textStyle={"body-md-regular"} color={"#6F6F6C"}>
          관심 상품 목록
        </Text>
        <Text textStyle={"body-md-bold"} color={"#1272EF"}>
          {favSkus.length}
        </Text>
      </Flex>
      <Box
        ref={parentRef}
        overflow={"auto"}
        height={"358px"}
        padding={"12px"}
        borderRadius={"8px"}
        border={"1px solid #D4D4D1"}
      >
        <FieldArray name={"favoriteProducts"}>
          {({ remove, push, replace }) => (
            <>
              {favoriteProducts.length === 0 && (
                <NoResultCustom
                  text={"등록된 관심 상품이 없습니다."}
                  size={"28px"}
                />
              )}
              {favoriteProducts.map((rowItem, index) => {
                const { id, sku, image_urls, brand_name, added } = rowItem;
                const isRequested = requestSku.includes(sku);

                return (
                  <FavoriteProductEditItem
                    key={`${id}-${index}`}
                    src={image_urls?.at(0) || "/icons-v1_1/null.png"}
                    sku={sku}
                    brandName={brand_name}
                    added={added}
                    onClick={() => {
                      if (isRequested) {
                        setFieldValue(
                          "requestSku",
                          requestSku.filter((item) => item !== sku)
                        );
                        setFieldValue(
                          "favoriteProducts",
                          favoriteProducts.filter((item) => item.sku !== sku)
                        );
                        return;
                      }
                      replace(index, { ...rowItem, added: !added });
                    }}
                  />
                );
              })}
            </>
          )}
        </FieldArray>
      </Box>
    </>
  );
}

export default AddedSkuList;
